import { useState, type CSSProperties } from "react";
import { ImageOff } from "lucide-react";
import { Button } from "@/components/ui";

interface Props {
  src?: string | null;
  alt: string;
  className?: string;
  style?: CSSProperties;
  onRetry: () => void | Promise<void>;
  onUnavailable?: () => void;
}

/** Patient photographs use only API-issued temporary links, never public-path fallbacks. */
export function PrivateGalleryImage({ src, alt, className, style, onRetry, onUnavailable }: Props) {
  const [failedSource, setFailedSource] = useState<string | null>(null);
  if (!src || src === failedSource) {
    return (
      <div className={`${className ?? ""} flex flex-col items-center justify-center gap-2 bg-app-surface-muted p-4 text-center`} style={style}>
        <ImageOff className="size-5 text-app-fg-muted" aria-hidden="true" />
        <p className="text-sm text-app-fg-muted">Foto de {alt.toLocaleLowerCase("pt-BR")} indisponível</p>
        <Button variant="outline" size="sm" onPointerDown={event => event.stopPropagation()} onMouseDown={event => event.stopPropagation()} onClick={async () => { await onRetry(); setFailedSource(null); }}>Recarregar fotos</Button>
      </div>
    );
  }
  return <img src={src} alt={alt} className={className} style={style} draggable={false} onError={() => { setFailedSource(src); onUnavailable?.(); }} />;
}
